import { createTheme } from "@material-ui/core/styles";
import ThemeColors from "./colors";

const { breakpoints } = createTheme({});

const typograpghy = {
  h1: {
    fontSize: 28,
    fontWeight: 700,
    color: ThemeColors.lightWhiteColor,
    [breakpoints.down("md")]: {
      fontSize: 26,
    },
  },
  h2: {
    fontSize: 26,
    color: ThemeColors.lightWhiteColor,
    [breakpoints.down("md")]: {
      fontSize: 24,
    },
  },
  h3: {
    fontSize: 24,
    color: ThemeColors.lightWhiteColor,
    [breakpoints.down("md")]: {
      fontSize: 22,
    },
  },
  h4: {
    fontSize: 22,
    color: ThemeColors.lightWhiteColor,
    [breakpoints.down("md")]: {
      fontSize: 20,
    },
  },
  h5: {
    fontSize: 20,
    color: ThemeColors.lightWhiteColor,
    [breakpoints.down("md")]: {
      fontSize: 18,
    },
  },
  h6: {
    fontSize: 18,
    color: ThemeColors.lightWhiteColor,
    [breakpoints.down("md")]: {
      fontSize: 16,
    },
  },
  body1: {
    fontSize: 16,
    color: ThemeColors.lightWhiteColor,
    [breakpoints.down("md")]: {
      fontSize: 14,
    },
  },
  body2: {
    fontSize: 14,
    color: ThemeColors.lightWhiteColor,
    [breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
  subtitle1: {
    fontSize: 12,
    color: ThemeColors.lightWhiteColor,
    [breakpoints.down("md")]: {
      fontSize: 11,
    },
  },
  subtitle2: {
    fontSize: 11,
    color: ThemeColors.lightWhiteColor,
    [breakpoints.down("md")]: {
      fontSize: 10,
    },
  },
  caption: {
    fontSize: 9,
    color: ThemeColors.lightWhiteColor,
    [breakpoints.down("md")]: {
      fontSize: 8,
    },
  },
  button: {
    color: ThemeColors.whiteColor,
    borderRadius: 10,
    textTransform: "none",
    fontSize: 14,
    [breakpoints.down("md")]: {
      fontSize: 12,
    },
  },
};

const theme = createTheme({
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": ["Poppins"],
      },
    },
    MuiButton: {
      text: {
        fontSize: 24,
      },
    },
    MuiTypography: {
      ...typograpghy,
    },
  },
  palette: {
    type: "dark",
    primary: {
      main: ThemeColors.lightPurpleColor,
      contrastText: ThemeColors.whiteColor,
    },
    secondary: {
      main: ThemeColors.purpleColor,
      contrastText: ThemeColors.whiteColor,
    },
    error: {
      main: ThemeColors.lightRedColor,
      dark: ThemeColors.redColor,
    },
    text: {
      primary: ThemeColors.lightWhiteColor,
      secondary: ThemeColors.lightBlueColor,
      hint: ThemeColors.whiteColor,
      disabled: ThemeColors.purpleColor,
    },
    background: {
      default: ThemeColors.backgroundColor,
      paper: ThemeColors.backgroundPaperColor,
    },
    action: {
      selected: ThemeColors.blackColor,
      active: ThemeColors.greyColor,
      disabled: ThemeColors.lightGreyColor,
    },
    divider: ThemeColors.greyColor,
  },
  typography: {
    fontFamily: "Poppins",
    ...typograpghy,
  },
});

export default theme;
